import { getAnalytics } from 'firebase/analytics';
import { getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getRemoteConfig } from 'firebase/remote-config';
import { getStorage } from 'firebase/storage';
import './bootstrap';

const app = getApp();

export const firebaseClient = {
  app,
  get analytics() {
    return getAnalytics(app);
  },
  get auth() {
    return getAuth(app);
  },
  get db() {
    return getFirestore(app);
  },
  get functions() {
    return getFunctions(app);
  },
  get remoteConfig() {
    return getRemoteConfig(app);
  },
  get storage() {
    return getStorage(app);
  },
};
